import { render } from "./SideContactComponent.vue?vue&type=template&id=16c33136"
import script from "./SideContactComponent.vue?vue&type=script&lang=js"
export * from "./SideContactComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__